import { CMCD_FORMATTER_MAP } from './CMCD_FORMATTER_MAP.js';
/**
 * The default formatters for CMCD values.
 *
 * @group CMCD
 *
 * @beta
 *
 * @deprecated Use `CMCD_FORMATTER_MAP` instead.
 */
export const CmcdFormatters = CMCD_FORMATTER_MAP;
//# sourceMappingURL=CmcdFormatters.js.map